import React from 'react';
import { render } from 'react-dom';

// Styles (global).
import 'sanitize.css/sanitize.css';
import './styles.css';

// Utils.
import './utils/polyfills';
import registerServiceWorker from './utils/registerServiceWorker';

// Containers.
import App from './containers/App';

//------------------------------------------------------------------------------

// Render to DOM.
render(<App />, document.getElementById('root'));

// Init offline cache/capability.
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js